import { Customer } from './customer';
import { Tracker } from './tracker';
import { CollaboratorType } from './collaborator-type';

//Collaborator
export class Driver {

    public id:number;
    public name:string;
    public lastName:string;
    
    public cnh:string;
    public cnhDate:Date;

    public admissionDate:Date;

    public personalPhone:string;
    public coorpPhone:string

    public customer:Customer;
    public tracker:Tracker;

    public collaboratorType:CollaboratorType;

    //Base cadastral de cálculo para os custos logísticos
    public logisticCostKm:number;
    public logisticCostWeight:number;

    //Dados para controles nas rotas executadas e planejadas
    public logisticCostKmPlanned:number;
    public logisticCostWeightPlanned:number;
    public logisticCostKmExecuted:number;
    public logisticCostWeightExecuted:number;

    //Endereço
    public address : string;
    public number : string;
    public complement : string;
    public neighborhood : string;
    public city : string;
    public state : string;
    public country : string;
    public zipcode : string;
    public lat:string;
    public lng:string;

    constructor (id:number, name:string, lastName:string, 
                cnh:string, customer:Customer, tracker:Tracker, 
                cnhDate:Date, admissionDate:Date, personalPhone:string, coorpPhone:string,
                address:string, number:string, complement : string, neighborhood : string,
                city:string, state:string, country:string, zipcode:string, lat:string, lng:string) {
        this.id = id;
        this.name = name;
        this.lastName = lastName;
        this.cnh = cnh;
        this.customer = customer;
        this.tracker = tracker;
        this.cnhDate = cnhDate;
        this.admissionDate = admissionDate;
        this.personalPhone = personalPhone;
        this.coorpPhone = coorpPhone;
        this.address = address;
        this.number = number;
        this.complement = complement;
        this.neighborhood = neighborhood;
        this.city = city;
        this.state = state;
        this.country = country;
        this.zipcode = zipcode;
        this.lat = lat;
        this.lng = lng;        
    }

    get fullName() {
        if (this.name && this.lastName) {
            return this.name + ' ' + this.lastName;
        } else if (this.name && !this.lastName) {  
            return this.name;
        } else if (!this.name && this.lastName) {
            return this.lastName;
        }
        return '';
    }

    get collaboratorTypeName() {
        if (this.collaboratorType) {
            return this.collaboratorType.name;
        }
        return '';
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/driver.ts